"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var message_exports = {};
__export(message_exports, {
  ActivityUpdateType: () => ActivityUpdateType,
  MessageType: () => MessageType,
  linkPreviewType: () => linkPreviewType
});
module.exports = __toCommonJS(message_exports);
var MessageType = /* @__PURE__ */ ((MessageType2) => {
  MessageType2["Text"] = "text";
  MessageType2["Activity"] = "activity";
  return MessageType2;
})(MessageType || {});
var ActivityUpdateType = /* @__PURE__ */ ((ActivityUpdateType2) => {
  ActivityUpdateType2["Attribute"] = "attribute";
  ActivityUpdateType2["Tag"] = "tag";
  ActivityUpdateType2["Collaborators"] = "collaborators";
  ActivityUpdateType2["Type"] = "type";
  ActivityUpdateType2["Process"] = "process";
  ActivityUpdateType2["CollaborativeChange"] = "collaborativeChange";
  return ActivityUpdateType2;
})(ActivityUpdateType || {});
const linkPreviewType = "application/vnd.huly.link-preview";
//# sourceMappingURL=message.js.map
